import clsx from 'clsx'
import { WidgetHeader } from 'components/WidgetHeader'
import { ChatDetail } from 'components/chats/ChatDetail'
import { ChatBottomBar } from 'components/ChatBottomBar'
import { ChatTextInput } from 'components/ChatTextInput'
import { useSelector } from 'react-redux'
import { selectChatId } from 'store/messages'
import { ChatsList } from 'components/chats/ChatsList'
import { useGetBotMode } from 'hooks/useGetBotMode'
import { ModalOutlet } from 'providers/ModalProvider'
import { PortalToastContainer } from 'components/ui/PortalToastContainer'
import { CookieConsent } from 'components/cookie/CookieConsent'

export const WidgetContent = () => {
  const chatId = useSelector(selectChatId)
  const { isAppMode } = useGetBotMode()

  const box = (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-clip rounded-2xl border border-border bg-background">
      <WidgetHeader />
      {!chatId && <ChatsList />}
      {!!chatId && (
        <>
          <ChatDetail />
          <ChatBottomBar>
            <ChatTextInput />
          </ChatBottomBar>
        </>
      )}
      <PortalToastContainer topOffset={80} />
      <CookieConsent surface="widget" />
      <ModalOutlet />
    </div>
  )

  if (isAppMode) {
    return (
      <div className="fixed bottom-1 mt-3 flex h-full w-screen flex-col rounded-2xl font-sans" key="widget">
        {box}
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'animate-slide-up-widget fixed right-5 bottom-5 z-50 flex h-[calc(99dvh-96px)] max-h-160 w-[400px] max-w-[90vw] flex-col rounded-2xl font-sans',
      )}
    >
      {box}
    </div>
  )
}
